import create from "zustand";
import { produce } from "immer";
interface UserAuthResponse {
  jwt: string | null;
  id: number | string;
  username: string;

  firstName: string;
  lastName: string;
  role: number | string;
  org_id: number | string;
  org_name: string;
  email: string;
  phone: string;
  profile_pic: string;
  status?: number;
  error?: string;
}

export interface UserState {
  mspLogo: string;
}

const INITIAL_USER: UserState = {
  mspLogo: "",
};

interface UserActions {
  handleLogin: (data: { jwt: string; id: string; isLoading: boolean }) => void;
  handleUser: (user: any) => void;

  handleMspLogo: (logo: string) => void;
  updateFormData: (params: {
    key: "studentId" | "eventTrackId";
    value: string;
  }) => void;
}

export const useUserStore = create<UserState & UserActions>((set) => ({
  ...INITIAL_USER,
  handleMspLogo: (mspLogo) => {
    set(
      produce((state) => {
        state.mspLogo = mspLogo;
      })
    );
  },
}));
